import request from "../http/index";

/**
 *
 * @param {*} data
 * @returns 首页Banner
 */

export async function BannerShow(data = {}) {
	const res = await request.post("/api/cp/Banner/Show", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 公司信息的菜单状态
 */

export async function UserInfoLicenseMenu(data = {}) {
	const res = await request.post("/api/ua/UserInfo/LicenseMenu", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->列表
 */

export async function APPRelationProviderList(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->查看附件数据
 */

export async function APPRelationProviderInfo(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->查看图片
 */

export async function APPRelationProviderGetImages(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/GetImages", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->导出
 */

export async function APPRelationProviderExport(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->新增
 */

export async function APPRelationProviderAdd(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->修改
 */

export async function APPRelationProviderEdit(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->删除
 */

export async function APPRelationProviderDelete(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->编辑界面上传图片
 */

export async function APPRelationProviderUploadImageByEdit(data = {}) {
	const res = await request.post(
		"/api/ba/APPRelationProvider/UploadImageByEdit",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->提交
 */

export async function APPRelationProviderSubmit(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/Submit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->通过审批
 */

export async function APPRelationProviderApprove(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/Approve", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->驳回
 */

export async function APPRelationProviderReject(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/Reject", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->配送商医院备案->撤回
 */

export async function APPRelationProviderRevoke(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/Revoke", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取营业执照信息
 */

export async function LicenseGetBusinessLicense(data = {}) {
	const res = await request.post("/api/ba/License/GetBusinessLicense", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 提交营业执照信息
 */

export async function LicenseAdd_BusinessLicense(data = {}) {
	const res = await request.post("/api/ba/License/Add_BusinessLicense", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 上传营业执照图片
 */

export async function LicenseUploadBusinessLicensePhoto(data = {}) {
	const res = await request.post(
		"/api/ba/License/UploadBusinessLicensePhoto",
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}

//医疗器械经营许可证
/**
 *
 * @param {*} data
 * @returns 上传医疗器械经营许可证图片
 */

export async function LicenseUploadBusinessPermissionPhoto(data = {}) {
	const res = await request.post(
		"/api/ba/License/UploadBusinessPermissionPhoto",
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 提交医疗器械经营许可证信息
 */

export async function LicenseAdd_BusinessLicensePermission(data = {}) {
	const res = await request.post(
		"/api/ba/License/Add_BusinessPermission",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取医疗器械经营许可证信息
 */

export async function LicenseGetBusinessPermission(data = {}) {
	const res = await request.post("/api/ba/License/GetBusinessPermission", data);
	return res.data;
}
//第二类医疗器械备案凭证
/**
 *
 * @param {*} data
 * @returns 上传第二类医疗器械备案凭证图片
 */

export async function LicenseUploadBusinessRecordPhoto(data = {}) {
	const res = await request.post(
		"/api/ba/License/UploadBusinessRecordPhoto",
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 提交第二类医疗器械备案凭证信息
 */

export async function LicenseAdd_BusinessRecord(data = {}) {
	const res = await request.post("/api/ba/License/Add_BusinessRecord", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取第二类医疗器械备案凭证信息
 */

export async function LicenseGetBusinessRecord(data = {}) {
	const res = await request.post("/api/ba/License/GetBusinessRecord", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取工作报告列表
 */

export async function HospitalProcessList(data = {}) {
	const res = await request.post("/api/ba/Hospital/ProcessList", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取工作报告列表（获取入院进度列表）
 */

export async function HospitalEditProcess(data = []) {
	const res = await request.post("/api/ba/Hospital/EditProcess", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取入院进度操作记录
 */

export async function HospitalGetProcessOperation(data = []) {
	const res = await request.post("/api/ba/Hospital/GetProcessOperation", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取入院进度 导出
 */
export async function HospitalExportProcessList(data = {}) {
	const res = await request.post("/api/ba/Hospital/ExportProcessList", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取入院进度导入
 */
export async function HospitalImportProcess(data = {}) {
	const res = await request.post("/api/ba/Hospital/ImportProcess", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取授权列表
 */
export async function BusinessAuthorityList(data = {}) {
	const res = await request.post("/api/ba/BusinessAuthority/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取授权列表_查看
 */
export async function BusinessAuthorityInfo(data = {}) {
	const res = await request.post("/api/ba/BusinessAuthority/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取授权列表_取消盖章
 */
export async function BusinessAuthorityRemoveAttachment(data = {}) {
	const res = await request.post("/api/ba/BusinessAuthority/RemoveAttachment", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取授权列表_盖章证照照上传
 */
export async function BusinessAuthorityUpLoadAttachment(data = {}, BAMID) {
	const res = await request.post(
		"/api/ba/BusinessAuthority/UpLoadAttachment?BAMID=" + BAMID,
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取授权列表_批量导入
 */
export async function BusinessAuthorityUpLoadAttachments(data = {}) {
	const res = await request.post(
		"/api/ba/BusinessAuthority/UpLoadAttachments",
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取授权列表_导入授权书
 */
export async function BusinessAuthorityImportBusinessAuthority(data = {}) {
	const res = await request.post(
		"/api/ba/BusinessAuthority/ImportBusinessAuthority",
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权书下载模板
 */
export async function BusinessAuthorityDownloadTemplet(data = {}) {
	const res = await request.post(
		"/api/ba/BusinessAuthority/DownloadTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权书下载/打印（单行）
 */
export async function BusinessAuthorityGeneratePdf(data = {}) {
	const res = await request.post(
		"/api/ba/BusinessAuthority/GeneratePdf",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权书下载（多行）
 */
export async function BusinessAuthorityGeneratePdfList(data = {}) {
	const res = await request.post(
		"/api/ba/BusinessAuthority/GeneratePdfList",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 授权书打印（多行）
 */
export async function BusinessAuthorityPrintPdfList(data = {}) {
	const res = await request.post(
		"/api/ba/BusinessAuthority/PrintPdfList",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 授权书审核
 */
export async function BusinessAuthorityVerify(data = {}) {
	const res = await request.post("/api/ba/BusinessAuthority/Verify", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权书删除
 */
export async function BusinessAuthorityDelete(data = {}) {
	const res = await request.post("/api/ba/BusinessAuthority/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权书作废
 */
export async function BusinessAuthorityDisable(data = {}) {
	const res = await request.post("/api/ba/BusinessAuthority/Disable", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 授权书导出
 */
export async function BusinessAuthorityExport(data = {}) {
	const res = await request.post("/api/ba/BusinessAuthority/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权书驳回
 */
export async function BusinessAuthorityReject(data = {}) {
	const res = await request.post("/api/ba/BusinessAuthority/Reject", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取指标生成_查看
 */
export async function CustomerQuotaView(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/View", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取指标生成_打印/下载
 */
export async function CustomerQuotaGeneratePdf(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/GeneratePdf", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取指标生成_导入指标
 */
export async function CustomerQuotaImport(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取指标生成_审核 
 */
export async function CustomerQuotaVerify(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/Verify", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取指标生成_确认 
 */
export async function CustomerQuotaConfirm(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/Confirm", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 获取指标生成_驳回 
 */
export async function CustomerQuotaReject(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/Reject", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 资讯发布标记单条已读
 */
export async function InformationView(data = {}) {
	const res = await request.post("/api/cp/Information/View", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 资讯发布标记全部已读
 */
export async function InformationSetAllView(data = {}) {
	const res = await request.post("/api/cp/Information/SetAllView", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 合规培训标记单条已读
 */
export async function ComplianceView(data = {}) {
	const res = await request.post("/api/cp/Compliance/View", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 合规培训标记全部已读
 */
export async function ComplianceSetAllView(data = {}) {
	const res = await request.post("/api/cp/Compliance/SetAllView", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 预警类型
 */
export async function HelperWarningType(data = {}) {
	const res = await request.post("/api/helper/Helper/WarningType", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 预警列表
 */
export async function HomeRemindGetForWarning(data = {}) {
	const res = await request.post("/api/helper/HomeRemind/GetForWarning", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 消息提醒数量
 */
export async function HomeRemindGetMessageCount(data = {}) {
	const res = await request.post("/api/helper/HomeRemind/GetMessageCount", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 待办事项列表
 */
export async function HomeRemindGetForWarningSimple(data = {}) {
	const res = await request.post("/api/helper/HomeRemind/GetForWarningSimple", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 预警详情
 */
export async function HomeRemindGetWainingDetail(data = {}) {
	const res = await request.post(
		"/api/helper/HomeRemind/GetWainingDetail",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页商业报表左边出库公司
 */
export async function HelperOrganization(data = {}) {
	const res = await request.post(
		"/api/helper/Helper/Organization",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 首页指标销售额上面的和左下的达成率
 */
export async function SMSReportPurchaseQuotaList(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/PurchaseQuotaList",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页指标年度指标达成率
 */
export async function SMSReportYearPurchaseQuotaList(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/YearPurchaseQuotaList",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 资料下载列表
 */
export async function DataDownloadListApi(data = {}) {
	const res = await request.post("/api/cp/DataDownload/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 新增资料
 */
export async function DataDownloadAdd(data = {}) {
	const res = await request.post("/api/cp/DataDownload/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 修改资料
 */
export async function DataDownloadEdit(data = {}) {
	const res = await request.post("/api/cp/DataDownload/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 删除
 */
export async function DataDownloadDelete(data = {}) {
	const res = await request.post("/api/cp/DataDownload/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 详情
 */
export async function DataDownloadInfo(data = {}) {
	const res = await request.post("/api/cp/DataDownload/Info", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 上传附件
 */

export async function DataDownloadUpLoadAttachment(data = {}) {
	const res = await request.post(
		"/api/cp/DataDownload/UpLoadAttachment",
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权申请=>新增
 */
export async function APPBusinessAuthorityAdd(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权申请=>列表 || 指标申请->新增
 */
export async function APPBusinessAuthorityList(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权申请=>查看
 */
export async function APPBusinessAuthorityInfo(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/Info", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 授权申请=>修改
 */
export async function APPBusinessAuthorityEdit(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 授权申请=>删除
 */
export async function APPBusinessAuthorityDelete(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权申请=>导出
 */

export async function APPBusinessAuthorityExport(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权申请=>提交
 */

export async function APPBusinessAuthoritySubmit(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/Submit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权申请=>驳回
 */

export async function APPBusinessAuthorityReject(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/Reject", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 授权申请=>驳回
 */

export async function APPBusinessAuthorityRevoke(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/Revoke", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 授权申请=>审批通过
 */

export async function APPBusinessAuthorityApprove(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/Approve", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 授权申请=>审批流程
 */

export async function APPBusinessAuthorityGetHostory(data = {}) {
	const res = await request.post(
		"/api/ba/APPBusinessAuthority/GetHostory",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 授权申请=>模板下载
 */
export async function APPBusinessAuthorityDownloadTemplet(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/DownloadTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 授权申请=>模板导入
 */
export async function ImportAPPBusinessAuthority(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/Import", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 审批流状态
 */

export async function HelperApprovalFlowStatus(data = {}) {
	const res = await request.get("/api/helper/Helper/ApprovalFlowStatus", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标默认分摊比例->列表
 */

export async function QuotaDefaultRatioList(data = {}) {
	const res = await request.post("/api/ba/QuotaDefaultRatio/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标默认分摊比例->详情
 */

export async function QuotaDefaultRatioInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerRatio/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标默认分摊比例->新增
 */

export async function QuotaDefaultRatioAdd(data = {}) {
	const res = await request.post("/api/ba/QuotaDefaultRatio/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标默认分摊比例->修改
 */

export async function QuotaDefaultRatioEdit(data = {}) {
	const res = await request.post("/api/ba/QuotaDefaultRatio/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标申请->新增
 */

export async function APPCustomerQuotaAdd(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标申请->列表
 */

export async function APPCustomerQuotaList(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标申请->新增带出往年数据
 */

export async function APPCustomerQuotaGetAPPCustomerQuotaForAddNew(data = {}) {
	const res = await request.post(
		"/api/ba/APPCustomerQuota/GetAPPCustomerQuotaForAddNew",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标申请->查看
 */

export async function APPCustomerQuotaInfo(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标申请->修改
 */

export async function APPCustomerQuotaEdit(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标申请->删除
 */

export async function APPCustomerQuotaDelete(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标申请->提交
 */

export async function APPCustomerQuotaSubmit(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/Submit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标申请->驳回
 */

export async function APPCustomerQuotaReject(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/Reject", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标申请->撤回
 */

export async function APPCustomerQuotaRevoke(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/Revoke", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标申请->审批通过
 */

export async function APPCustomerQuotaApprove(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/Approve", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标申请->审批流程
 */

export async function APPCustomerQuotaGetHostory(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/GetHostory ", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 指标申请->导出
 */

export async function APPCustomerQuotaExport(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->列表
 */

export async function APPCustomerList(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/List ", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->新增带出数据
 */

export async function APPCustomerGetAPPCustomerForAddNew(data = {}) {
	const res = await request.post(
		"/api/ba/APPCustomer/GetAPPCustomerForAddNew",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  经销商申请->新增
 */

export async function APPCustomerAdd(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->详情
 */

export async function APPCustomerInfo(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->修改
 */

export async function APPCustomerEdit(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->提交
 */

export async function APPCustomerSubmit(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/Submit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->驳回
 */

export async function APPCustomerReject(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/Reject", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->撤回
 */

export async function APPCustomerRevoke(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/Revoke", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->审批通过
 */

export async function APPCustomerApproval(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/Approval", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->审批流程
 */

export async function APPCustomerGetHistory(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/GetHistory", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  经销商申请->删除
 */

export async function APPCustomerDelete(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->开户状态变更
 */

export async function APPCustomerDoOpenAccount(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/DoOpenAccount", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->备案开户状态
 */

export async function HelperOpenAccountStatusByBuyFromHome(data = {}) {
	const res = await request.get(
		"/api/helper/Helper/OpenAccountStatusByBuyFromHome",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->签约->合同状态
 */

export async function HelperContractStatus(data = {}) {
	const res = await request.get(
		"/api/helper/Helper/ContractStatus",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->签约->列表
 */

export async function CustomerContractCustomerList(data = {}) {
	const res = await request.post(
		"/api/ba/CustomerContract/CustomerList",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->签约->提交
 */

export async function CustomerContractAddContract(data = {}) {
	const res = await request.post(
		"/api/ba/CustomerContract/AddContract",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->签约->合同确认
 */

export async function CustomerContractVerify(data = {}) {
	const res = await request.post(
		"/api/ba/CustomerContract/Verify",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  经销商申请->签约->合同驳回
 */

export async function CustomerContractReject(data = {}) {
	const res = await request.post(
		"/api/ba/CustomerContract/Reject",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  经销商申请->签约->上传文件
 */

export async function CustomerContractUpLoadAttachment(data = {}) {
	const res = await request.post(
		"/api/ba/CustomerContract/UpLoadAttachment",
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  公司信息->列表
 */

export async function CustomerContractList(data = {}) {
	const res = await request.post(
		"/api/ba/CustomerContract/List",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  公司信息->提交
 */

export async function CustomerContractSignContract(data = {}) {
	const res = await request.post(
		"/api/ba/CustomerContract/SignContract",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 经销商申请->导出
 */

export async function APPCustomerExport(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  经销商申请->上传图片和文件
 */

export async function APPCustomerUploadImageByEdit(data = {}) {
	const res = await request.post(
		"/api/ba/APPCustomer/UploadImageByEdit",
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 经销商申请->模板下载
 */
export async function APPCustomerDownloadTemplet(data = {}) {
	const res = await request.post("/api/ba/APPCustomer/DownloadTemplet", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->开户许可证进度
 */
export async function OpenAccountGetOpenAccountStatus(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/GetOpenAccountStatus",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->文件上传
 */
export async function OpenAccountUpLoadAttachment(data = {}) {
	const res = await request.post("/api/ba/OpenAccount/UpLoadAttachment", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->开户许可证提交
 */

export async function OpenAccountAddOpenAccount(data = {}) {
	const res = await request.post("/api/ba/OpenAccount/AddOpenAccount", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->获取开户许可证
 */
export async function OpenAccountGetOpenAccount(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/GetOpenAccount",
		data
	);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->经销商信息表提交
 */

export async function OpenAccountAddCusInfo(data = {}) {
	const res = await request.post("/api/ba/OpenAccount/AddCusInfo", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->获取经销商信息表
 */
export async function OpenAccountGetCusInfo(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/GetCusInfo",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 经销商信息模板下载
 */

export async function OpenAccountDownloadCusInfoTemplet(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/DownloadCusInfoTemplet",
		data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->承诺书提交
 */

export async function OpenAccountAddCommitmentLetter(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/AddCommitmentLetter",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->承诺书获取
 */

export async function OpenAccountGetCommitmentLetter(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/GetCommitmentLetter",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->承诺书模板下载
 */

export async function OpenAccountDownloadCommitmentLetterTemplet(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/DownloadCommitmentLetterTemplet",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->关联申明提交
 */

export async function OpenAccountAddAffiliateStatement(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/AddAffiliateStatement",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->关联申明获取
 */

export async function OpenAccountGetAffiliateStatement(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/GetAffiliateStatement",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->关联申明模板下载
 */

export async function OpenAccountDownloadAffiliateStatementTemplet(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/DownloadAffiliateStatementTemplet",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->获取业务员授权书
 */

export async function OpenAccountGetSalerBusinessAuthority(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/GetSalerBusinessAuthority",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->业务员授权书提交
 */

export async function OpenAccountAddSalerBusinessAuthority(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/AddSalerBusinessAuthority",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->业务员模板下载
 */

export async function OpenAccountDownloadSalerBusinessAuthorityTemplet(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/DownloadSalerBusinessAuthorityTemplet",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->联系信息提交
 */

export async function OpenAccountAddFileContact(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/AddFileContact",
		data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 公司信息->首营信息->联系信息获取
 */

export async function OpenAccountGetFileContact(data = {}) {
	const res = await request.post(
		"/api/ba/OpenAccount/GetFileContact",
		data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 文件管理
 */

export async function FileManageList(data = {}) {
	const res = await request.post(
		"/api/cp/FileManage/List",
		data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 文件管理- 上传采购指标
 */

export async function CustomerQuotaUpLoadAttachment(data = {}) {
	const res = await request.post(
		"/api/ba/CustomerQuota/UpLoadAttachment",
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 文件管理-提交
 */

export async function CustomerQuotaAddAtachment(data = {}) {
	const res = await request.post(
		"/api/ba/CustomerQuota/AddAtachment",
		data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 文件管理没文件情况调用接口
 */
export async function FileManageDownloadFile(data = {}) {
	const res = await request.post(
		"/api/cp/FileManage/DownloadFile",
		data, {
			responseType: "blob",
		}
	);
	return res;
}
/**
 *
 * @param {*} data
 * @returns 产品追溯-列表
 */

export async function ProductTraceability(data = {}) {
	const res = await request.post(
		"/api/report/WMSReport/ProductTraceability",
		data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 指标中心-二级销售（大区）
 */

export async function HelperAreaMan(data = {}) {
	const res = await request.post(
		"/api/helper/Helper/AreaMan",
		data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 指标中心-三级销售（地区）
 */

export async function HelperRegionMan(data = {}) {
	const res = await request.post(
		"/api/helper/Helper/RegionMan",
		data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 指标中心-销售员
 */

export async function HelperSalesMan(data = {}) {
	const res = await request.post(
		"/api/helper/Helper/SalesMan",
		data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 指标中心-LEVEL3下拉框选择框
 */

export async function HelperLEVEL3(data = {}) {
	const res = await request.post(
		"/api/helper/Helper/LEVEL3",
		data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 指标中心-LEVEL1_5下拉框选择框
 */

export async function HelperLEVEL1_5(data = {}) {
	const res = await request.post(
		"/api/helper/Helper/LEVEL1_5",
		data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 指标中心-中间部分图表
 */

export async function QuotaReportPurchaseQuotaInfo(data = {}) {
	const res = await request.post(
		"/api/report/QuotaReport/PurchaseQuotaInfo",
		data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 指标中心-采购中心-下部树状表格
 */

export async function QuotaReportPurchaseQuotaTreeTable(data = {}) {
	const res = await request.post(
		"/api/report/QuotaReport/PurchaseQuotaTreeTable",
		data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 指标中心-销售指标-下部树状表格
 */

export async function QuotaReportSalesQuotaTreeTable(data = {}) {
	const res = await request.post(
		"/api/report/QuotaReport/SalesQuotaTreeTable",
		data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 指标中心-库存透视
 */

export async function WMSReportStockPivotTable(data = {}) {
	const res = await request.post(
		"/api/report/WMSReport/StockPivotTable",
		data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 资料下载-资料类型
 */

export async function GetHelperDataDownloadType(data = {}) {
	const res = await request.get(
		"/api/helper/Helper/DataDownloadType",
		data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 主页管理-资料分类管理
 */

export async function DataDownloadClassList(data = {}) {
	const res = await request.post(
		"/api/ba/DataDownloadClass/List",
		data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 主页管理-资料分类详情
 */

export async function DataDownloadClassInfo(data = {}) {
	const res = await request.post(
		"/api/ba/DataDownloadClass/Info",
		data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 主页管理-资料分类删除
 */

export async function DataDownloadClassDelete(data = {}) {
	const res = await request.post(
		"/api/ba/DataDownloadClass/Delete",
		data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 主页管理-新增主分类
 */

export async function DataDownloadClassAdd(data = {}) {
	const res = await request.post(
		"/api/ba/DataDownloadClass/Add",
		data);
	return res.data;
}



/**
 *
 * @param {*} data
 * @returns 主页管理-编辑主分类
 */

export async function DataDownloadClassEdit(data = {}) {
	const res = await request.post(
		"/api/ba/DataDownloadClass/Edit",
		data);
	return res.data;
}




/**
 *
 * @param {*} data
 * @returns 主页管理-树分类
 */

export async function DataDownloadClassListForNode(data = {}) {
	const res = await request.post(
		"/api/ba/DataDownloadClass/ListForNode",
		data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 生产厂商列表
 */

export async function GetManufacturerList(data = {}) {
	const res = await request.post(
		"/api/ba/Manufacturer/List",
		data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 关联产品列表
 */

export async function GetProductDetail(data = {}) {
	const res = await request.post(
		"/api/ba/Product/GetDetail",
		data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 经营省份选中接口
 */

export async function GetCustomerProvinceID(data = {}) {
	const res = await request.post("/api/ba/Customer/GetCustomerProvinceID", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 保存省份相关数据
 */

export async function EditCustomerProvinceID(data = {}) {
	const res = await request.post("/api/ba/Customer/EditCustomerProvinceID", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 公司负责人选中接口
 */

export async function GetBOSSNameByInvClass(data = {}) {
	const res = await request.post("/api/ba/Customer/GetBOSSNameByInvClass", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 保存公司负责人数据
 */

export async function SetBOSSNameByInvClass(data = {}) {
	const res = await request.post("/api/ba/Customer/SetBOSSNameByInvClass", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 导入模板下载
 */

export async function DownloadImportProvinceTemplet(data = {}) {
	const res = await request.post("/api/ba/Customer/DownloadImportProvinceTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 导入经营省份
 */

export async function ImportProvinceData(data = {}) {
	const res = await request.post("/api/ba/Customer/ImportProvince", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 指标导入模板下载
 */

export async function DownloadAPPCustomerQuota(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/DownloadTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 指标导入
 */

export async function ImportAPPCustomerQuota(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/Import", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取授权书生成 备注
 */

export async function GetBusinessAuthorityMemo(data = {}) {
	const res = await request.post("/api/ba/BusinessAuthority/Get_Memo", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取授权书生成 备注  文件上传
 */

export async function UpLoadMemoAttachmentMemo(data = {}) {
	const res = await request.post("/api/ba/BusinessAuthority/UpLoadMemoAttachment", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取授权书生成 备注  保存
 */

export async function SetBusinessAuthorityMemo(data = {}) {
	const res = await request.post("/api/ba/BusinessAuthority/UpD_Memo", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取省级
 */
export async function GetHelperProvinceMan(data = {}) {
	const res = await request.post("/api/helper/Helper/ProvinceMan", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取配送商类型
 */
export async function GetHelperDispatcherType(data = {}) {
	const res = await request.post("/api/helper/Helper/DispatcherType", data);
	return res.data;
}

//////////////已消耗未付款//////////////

/**
 *
 * @param {*} data
 * @returns 获取已消耗未付款列表
 */
export async function GetSmsDispatchList(data = {}) {
	const res = await request.post("/api/sms/DispatchList/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取已消耗未付款详情
 */
export async function GetSmsDispatchDetail(data = {}) {
	const res = await request.post("/api/sms/DispatchList/Detail", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 导出已消耗未付款
 */
export async function ExportSmsDispatchData(data = {}) {
	const res = await request.post("/api/sms/DispatchList/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 删除已消耗未付款
 */
export async function DeleteSmsDispatchData(data = {}) {
	const res = await request.post("/api/sms/DispatchList/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 已消耗未付款状态
 */
export async function GetHelperPayStatus(data = {}) {
	const res = await request.post("/api/helper/Helper/PayStatus", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 经销商签约->导出
 */

export async function ContractCustomerExport(data = {}) {
	const res = await request.post("/api/ba/CustomerContract/CustomerExport", data, {
		responseType: "blob",
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 经销商指标-指标申请-年度指标导入模板下载
 */

export async function DownloadYearQuotaTempletQuota(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/DownloadYearQuotaTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 经销商指标-指标申请-年度指标导入
 */

export async function ImportYearAPPCustomerQuota(data = {}) {
	const res = await request.post("/api/ba/APPCustomerQuota/ImportYear", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 常见问题-列表
 */
export async function FAQList(data = {}) {
	const res = await request.post("/api/cp/FAQ/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 常见问题-详情
 */
export async function FAQInfo(data = {}) {
	const res = await request.post("/api/cp/FAQ/Info", data);
	return res.data;
}